/*
 * Native Possum — np-page.js
 * Behaviour for sections/main-np-page.liquid (see its header).
 * Loaded where it used to be written inline, without defer, so it runs at the same
 * moment as before (it sets up what the section looks like on load).
 */
  (function() {
    if (window.innerWidth > 768) return;

    var rte = document.querySelector('.np-page-content .rte');
    if (!rte) return;

    var headings = rte.querySelectorAll('h2');
    if (headings.length === 0) return;

    /* Find "Our Whakapapa" — everything before and including it stays visible.
       All h2s after it get wrapped in <details> accordions. */
    var whakapapaIndex = -1;
    for (var i = 0; i < headings.length; i++) {
      if (headings[i].textContent.trim().toLowerCase().indexOf('whakapapa') !== -1) {
        whakapapaIndex = i;
        break;
      }
    }

    /* If not found, collapse everything after the first h2 */
    var startIndex = whakapapaIndex >= 0 ? whakapapaIndex + 1 : 1;

    for (var j = startIndex; j < headings.length; j++) {
      var h2 = headings[j];
      var title = h2.textContent.trim();

      /* Collect all siblings between this h2 and the next h2 (or end) */
      var contentNodes = [];
      var sibling = h2.nextSibling;
      while (sibling) {
        if (sibling.nodeType === 1 && sibling.tagName === 'H2') break;
        contentNodes.push(sibling);
        sibling = sibling.nextSibling;
      }

      /* Build <details> element */
      var details = document.createElement('details');
      details.className = 'np-about-section';

      var summary = document.createElement('summary');
      summary.textContent = title;
      details.appendChild(summary);

      var contentDiv = document.createElement('div');
      contentDiv.className = 'np-about-section-content';

      contentNodes.forEach(function(node) {
        contentDiv.appendChild(node);
      });

      details.appendChild(contentDiv);

      /* Replace h2 with the <details> block */
      h2.parentNode.replaceChild(details, h2);
    }
  })();
